
export { TestConduitDisplay } from './TestConduitDisplay'
export { SiteNavBar } from './SiteNavBar'
export { SwmmSlider } from './SwmmSlider'
export { OutPeriodSlider } from './OutPeriodSlider'
export { OpenInpFile } from "./OpenInpFile"
export { OpenDefaultInpFile } from "./OpenDefaultInpFile"
export { OpenOutFile } from "./OpenOutFile"
export { OpenDefaultOutFile } from "./OpenDefaultOutFile"
export { OpenDefaultFiles } from "./OpenDefaultFiles"
export { OpenDefaultOutFileHeadless } from "./OpenDefaultOutFileHeadless"
export { OpenDefaultInpFileHeadless } from "./OpenDefaultInpFileHeadless"
export { OpenDefaultFilesHeadless } from "./OpenDefaultFilesHeadless"
export { DisplayHead } from "./DisplayHead"
export { TITLETextBox } from "./TITLETextBox"
export { UpdateModelButton } from "./UpdateModelButton"
export { ResetModelButton } from "./ResetModelButton"
export { ConduitsDropDown } from "./ConduitsDropDown"
export { ElProfile } from "./ElProfile"
export { OPTIONSFlowUnitsDropDown } from "./OPTIONSFlowUnitsDropDown"
export { OPTIONSInfilModelDropDown } from './OPTIONSInfilModelDropDown'
export { OPTIONSFlowRoutingDropDown } from './OPTIONSFlowRoutingDropDown'
export { OPTIONSLinkOffsetsDropDown } from './OPTIONSLinkOffsetsDropDown'
export { OPTIONSMinSlopeNUD } from './OPTIONSMinSlopeNUD'
export { OPTIONSAllowPondingDropDown } from './OPTIONSAllowPondingDropDown'
export { OPTIONSSkipSteadyStateDropDown } from './OPTIONSSkipSteadyStateDropDown'
export { OPTIONSStartDateDTP } from './OPTIONSStartDateDTP'
export { OPTIONSStartTimeInputTime } from './OPTIONSStartTimeInputTime'
export { OPTIONSReportStartDateDTP } from './OPTIONSReportStartDateDTP'
export { OPTIONSReportStartTimeInputTime } from './OPTIONSReportStartTimeInputTime'
export { OPTIONSEndDateDTP } from './OPTIONSEndDateDTP'
export { OPTIONSEndTimeInputTime } from './OPTIONSEndTimeInputTime'
export { OPTIONSSweepStartDTP } from './OPTIONSSweepStartDTP'
export { OPTIONSSweepEndDTP } from './OPTIONSSweepEndDTP'
export { OPTIONSDryDaysNUD } from './OPTIONSDryDaysNUD'
export { OPTIONSReportStepInputTime } from './OPTIONSReportStepInputTime'
export { OPTIONSWetStepInputTime } from './OPTIONSWetStepInputTime'
export { OPTIONSDryStepInputTime } from './OPTIONSDryStepInputTime'
export { OPTIONSRuleStepInputTime } from './OPTIONSRuleStepInputTime'
export { OPTIONSRoutingStepInputTime } from './OPTIONSRoutingStepInputTime'
export { OPTIONSInertialDampingDropDown } from './OPTIONSInertialDampingDropDown'
export { OPTIONSNormalFlowLimitedDropDown } from './OPTIONSNormalFlowLimitedDropDown'
export { OPTIONSForceMainEquationDropDown } from './OPTIONSForceMainEquationDropDown'
export { OPTIONSVariableStepNUD } from './OPTIONSVariableStepNUD'
export { OPTIONSLengtheningStepNUD } from './OPTIONSLengtheningStepNUD'
export { OPTIONSMinSurfareaNUD } from './OPTIONSMinSurfareaNUD'
export { OPTIONSMaxTrialsNUD } from './OPTIONSMaxTrialsNUD'
export { OPTIONSHeadToleranceNUD } from './OPTIONSHeadToleranceNUD'
export { OPTIONSSysFlowTolNUD } from './OPTIONSSysFlowTolNUD'
export { OPTIONSLatFlowTolNUD } from './OPTIONSLatFlowTolNUD'
export { OPTIONSMinimumStepNUD } from './OPTIONSMinimumStepNUD'
export { OPTIONSThreadsNUD } from './OPTIONSThreadsNUD'
export { OPTIONSIgnoreRainfallDropDown } from './OPTIONSIgnoreRainfallDropDown'
export { OPTIONSIgnoreSnowmeltDropDown } from './OPTIONSIgnoreSnowmeltDropDown'
export { OPTIONSIgnoreGroundwaterDropDown } from './OPTIONSIgnoreGroundwaterDropDown'
export { OPTIONSIgnoreRoutingDropDown } from './OPTIONSIgnoreRoutingDropDown'
export { OPTIONSIgnoreQualityDropDown } from './OPTIONSIgnoreQualityDropDown'
export { OPTIONSIgnoreRDIIDropDown } from './OPTIONSIgnoreRDIIDropDown'
export { OPTIONSSurchargeMethodDropDown } from './OPTIONSSurchargeMethodDropDown'
export { OUTLinksDropDown } from './OUTLinksDropDown'
export { OUTLinksMulti_Headless } from './OUTLinksMulti_Headless'
export { OUTSYS_Headless } from './OUTSYS_Headless'
export { OUTLinksMultiSelect } from './OUTLinksMultiSelect'
export { OUTNodesMultiSelect } from './OUTNodesMultiSelect'
export { OUTSubcatchMultiSelect } from './OUTSubcatchMultiSelect'
export { OUTDirectoryParser } from './OUTDirectoryParser'
export { OUTSeriesTransformer } from './OUTSeriesTransformer'
export { OUTDataType_Headless } from './OUTDataType_Headless'
export { OUTObjectType_Headless } from './OUTObjectType_Headless'
export { OUTLineChartTime_Recharts } from './OUTLineChartTime_Recharts'


export interface IModel {
  [key: string]: any;
}

export interface IDefault {
  [key: string]: any;
}

export type IModelUpdate = (arg0: any) => void

// handleChange updates the 'values' object within the controls.
export const handleChange_OPTIONS = (e:IDefault, model:(IModel|undefined), setModel:any) => {
  setModel({...model, OPTIONS : {...model?.OPTIONS, [e.name]: e.value}})
}

export const handleChange_TITLE = (e:IDefault, model:(IModel|undefined), setModel:any) => {
  setModel({...model, TITLE: e.value})
}

export const OUTDATATYPES = {
  SUBCATCH: {
    RAINFALL: 0,
    SNOWDEPTH: 1,
    EVAPORATIONLOSS: 2,
    INFILTRATIONLOSS: 3,
    RUNOFFRATE: 4,
    GWOUTFLOW: 5,
    GWELEVATION: 6,
    SOILMOISTURE: 7,
    POLLUTWASHOFF: 8
  },
  NODE: {
    DEPTHABOVEINVERT: 0,
    HYDRAULICHEAD: 1,
    VOLSTOREDPONDED: 2,
    LATERALINFLOW: 3,
    TOTALINFLOW: 4,
    OVERFLOW: 5
  },
  LINK: {
    FLOWRATE: 0,
    FLOWDEPTH: 1,
    FLOWVELOCITY: 2,
    FROUDENUMBER: 3,
    CAPACITY: 4
  },
  SYS: {
    AIRTEMPERATURE: 0,
    RAINFALL: 1,
    SNOWDEPTH: 2,
    INFILTRATION: 3,
    RUNOFF: 4,
    DRYWEATHERINFLOW: 5,
    GROUNDWATERINFLOW: 6,
    RDIIINFLOW: 7,
    EXTERNALINFLOW: 8,
    TOTALLATERALINFLOW: 9,
    FLOODINGOUTFLOW: 10,
    OUTFALLOUTFLOW: 11,
    STORAGEVOLUME: 12,
    EVAPORATIONRATE: 13,
    POTENTIALET: 14
  }
}

export enum objectTypes { 
  SUBCATCH = 'SUBCATCH', 
  NODE = 'NODE', 
  LINK = 'LINK', 
  SYS = 'SYS' 
}

// OUTPUT INTERFACES
// recharts outputs
export interface IOutRechartsLinear {
  type: string,   // 'LINK', 'NODE', 'SUBCATCH', or 'SYS'
  dataType: number, // zero indexed number for outputAreaWords, outputNodeWords, outputLinkWords or outputSysWords
  startPeriod: number, // The starting period for the visualization/data set.
  endPeriod: number, // The ending period for the visualization/data set.
  objNames: [], // Names of the objects in question.
  outdir: IOutDir, // Directory of output file, result of a component like OUTDirectoryParser, which calls parseInfo(outbin) on a binary file output.
  series: []  // Input structure to a Recharts object. Check for compatibility with multi-line style charts.
}

export interface IOutDir {
  ClosingRecords: any,
  OpeningRecords: any,
  ReportingInterval: any,
  ReportingVariables: any,
  objects: any
}

export const IOutRechartsLinear_default = {
  type: '',
  dataType: '',
  objNames: [],
  startPeriod: 1,
  // endPeriod of 0 ensures the entire timespan from start to end.
  endPeriod: 0,
  outdir: {OpeningRecords: {UnitsSystem: 'US'}},
  series: []
}

export function rechartsFormatXDateAxis(tickItem:any, index:number){
  tickItem = new Date(tickItem)
  return (tickItem.getMonth() + 1).toString().padStart(2, '0') + '/'
          + tickItem.getDate().toString().padStart(2, '0') + ' '
          + tickItem.getHours().toString().padStart(2, '0') + ':'
          + tickItem.getMinutes().toString().padStart(2, '0')
}

export const UIparams = { 
width: '100%', 
marginBottom: '10px',
display:  'inline-block',
outline:  '0',
border:  '0',
cursor:  'pointer',
fontWeight:  '600',
color:  '#fff',
fontSize:  '14px',   
padding:  '8px 0px',
borderRadius:  '50px',
backgroundColor:  '#99a9cc',
backgroundImage:  'linear-gradient(180deg,#7cafbb,#3456e0)',
boxShadow:  '0 4px 11px 0 rgb(37 44 97 / 15%), 0 1px 3px 0 rgb(93 100 148 / 20%)',
transition:  'all .2s ease-out'   
}

export const UIparamsFileOps = { 
width: '100%', 
marginBottom: '10px',
display:  'inline-block',
outline:  '0',
border:  '0',
cursor:  'pointer',
fontWeight:  '600',
color:  '#fff',
fontSize:  '14px',   
padding:  '8px 0px',
borderRadius:  '50px',
backgroundColor:  '#7cafff',
backgroundImage:  'linear-gradient(180deg,#457789,#123456)',
boxShadow:  '0 4px 11px 0 rgb(37 44 97 / 15%), 0 1px 3px 0 rgb(93 100 148 / 20%)',
transition:  'all .2s ease-out'
}

export const UIparamsText = {
width: '100%',
padding: '6px 12px',
fontSize: '12px',
fontWeight: '400',
lineHeight: '1.5',
color: '#212529',
backgroundColor: '#fff',
backgroundClip: 'padding-box',
border: '1px solid #ced4da',
appearance: 'none',
borderRadius: '4px',
transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
}

export const UIBackground = { backgroundSize: 'cover', padding: '10px', background: 'linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%)'}

export const UILabel = { display: 'flex', padding: '0px 0px 0px 10px' }
